// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------


// React
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

// Material UI
import { Button, Box, Stack } from "@mui/material";

// API
import { fetchUser, userRoles } from "../api/user-service";
import { UserContext } from "../Contexts";



// ----------------------------------------------------------------------------
//   Setup
// ----------------------------------------------------------------------------


const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const btnStyle = {
    mr: 2, 
    mb: 1, 
    fontSize: {
        xs: 7, 
        sm: 10, 
        md: 15
    }
}



// ----------------------------------------------------------------------------
//   Helper Component(s)
// ----------------------------------------------------------------------------


function NavButton( props ) {

    // Context
    const location = useLocation();

    // Component definition
    return (
        <Button component={NavLink}
            variant = { location.pathname === props.to ? 'contained' : 'outlined' }
            to = { props.to }
            sx = { btnStyle }
        >
            { props.children }
        </Button>
    )
}


// ----------------------------------------------------------------------------
//   Main Component
// ----------------------------------------------------------------------------


const Navigation = () => {

    // Context
    const { userData } = useContext( UserContext );

    const handleLogout = async () => {
        try {
            const res = await fetch(`${SERVER_URL}/auth/logout`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            });
            if (res.status === 200) {
                window.location.href = '/login';
            }
        } catch(err) {
            console.error('Error logging out:', err);
        }
    }
    
    return (
        <Box sx={{display: 'flex'}}>
            {userData.value?.role === userRoles.ADMIN ? (
                <Stack direction="row" columnGap="16px" marginX="16px">
                    <NavButton to="/admin"   >Admin Dashboard</NavButton>
                    <NavButton to="/student" >Videos</NavButton>
                </Stack>
            ) : ''}
            <Button variant="outlined" onClick={handleLogout} sx={btnStyle}>Sign Out</Button>
        </Box>
        
    )
}



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default Navigation;
